<template>
    <div>
        <Breadcrumbs main="HR" title="Compliance Create" />

        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div style="padding: 0px 12px; margin-bottom: 16px; display: flex; justify-content: end;">
                <b-button variant="primary" @click="goBack">
                    <div style="display: flex; align-items: center; gap: 8px;">
                        <feather type="arrow-left" size="18px"></feather>
                        <h7>Back</h7>
                    </div> 
                </b-button>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <px-card>
                        <div slot="with-padding">
                            <div class="form theme-form">

                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="form-group">
                                            <label>Title <span style="color: red;">*</span></label>
                                            <input class="form-control" type="text" placeholder="Enter compiance title" v-model="compliance.title">
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="form-group">
                                            <label>Compliance <span style="color: red;">*</span></label> 
                                            <!-- <b-form-textarea
                                                id="textarea-auto-height"
                                                rows="3"
                                                max-rows="8"
                                                placeholder="Enter compliance details"
                                                v-model="compliance.details"
                                            ></b-form-textarea> -->

                                            <vue-editor  v-model="compliance.details"></vue-editor>
                                            <!-- <ckeditor :editor="editor" placeholder="Enter compliance details..." v-model="compliance.details"></ckeditor> -->
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col">
                                        <div class="form-group mb-0">
                                            <button @click="onSubmit" class="btn btn-success mr-3" :disabled="isdisabled">Create</button>
                                            <router-link to="/hr/compliance">
                                                <button class="btn btn-danger" href="#">Go Back</button>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </px-card>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { VueEditor } from "vue2-editor";
export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker,
        VueEditor
    },

    data(){
        return {
            isdisabled:false,
            editor: ClassicEditor,
            compliance: {
                title: '',
                details: ''
            }
        };
    },

    methods: {
        goBack() {
            if (window.history.length > 1) {
                this.$router.back();
            } else {
                this.$router.push('/dashboard');
            }
        },

        onSubmit() {
            this.isdisabled = true

            this.compliance.title = this.compliance.title.trim() ? this.compliance.title : null;
            this.compliance.details = this.compliance.details.trim() ? this.compliance.details : null;

            if(this.compliance.title && this.compliance.details) {
                this.$store.dispatch("compliance/addCompliance", this.compliance).then(response => {
                    if(response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.compliance.title = '',
                        this.compliance.details = ''
                        setTimeout(() => {
                            this.$router.push('/hr/compliance')
                        }, 2000)
                        
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
            } else {
                this.compliance.title = '',
                this.compliance.details = ''
                Swal.fire({
                    title: "Error!",
                    text: 'You must enter all the mandatory fields (*)',
                    icon: "error"
                });
            }

            this.isdisabled = false
        }
    }
};
</script>
